import { create } from "zustand";
import { persist } from "zustand/middleware";
import { User } from "../models/api";

interface State {
  user: User | null;
}

interface Actions {
  setUser: (data: User) => void;
  clearUser: () => void;
}

const userStore = create(
  persist<State & Actions>(
    (set) => ({
      user: null,
      setUser: (data: User) => set(() => ({ user: data })),
      clearUser: () => {
        set(() => ({ user: null }));
        localStorage.clear();
      },
    }),
    { name: "user" }
  )
);

export default userStore;
